import Hero from '../../components/Hero'
import { Link } from 'react-router-dom'
import './CommercialCleaning.css'

const CommercialCleaning = () => {
  return (
    <>
      <Hero 
        title="Commercial Cleaning"
        subtitle="Tailored cleaning solutions designed to integrate seamlessly with your business needs."
        backgroundImage="/services/commercial/commercial.png"
        height="55.78125vh"
      />
      
      <section>
        <div className="section-header">
          <h2>Our Commercial Cleaning Services</h2>
        </div>
        <p>Adept Services delivers professional cleaning solutions for offices, warehouses, factories, and large commercial facilities. We focus on creating safe, hygienic, and presentable environments that reduce illness, boost productivity, and reflect your company’s professional image.</p>
        <div className="sub-services">
          <Link to="/contact" className="service-card-link">
            <article>
              <h3>Workplace Cleaning</h3>
              <p>Consistent daily and scheduled cleaning that keeps offices and commercial sites spotless, hygienic, and ready for business.</p>
            </article>
          </Link>
          <Link to="/contact" className="service-card-link">
            <article>
              <h3>Sanitisation &amp; Deep Clean</h3>
              <p>Targeted disinfection of high-touch and high-traffic areas using advanced methods to reduce germs and support workplace safety.</p>
            </article>
          </Link>
          <Link to="/contact" className="service-card-link">
            <article>
              <h3>Floor &amp; Surface Care</h3>
              <p>Specialist cleaning for carpets, tiles, and hard floors, including scrubbing, polishing, and protective treatments to maintain a professional finish.</p>
            </article>
          </Link>
          <Link to="/contact" className="service-card-link">
            <article>
              <h3>Glass &amp; Façade Cleaning</h3>
              <p>Safe, effective window and exterior cleaning for offices, warehouses, and multi-storey buildings, ensuring a clear and polished appearance.</p>
            </article>
          </Link>
          <Link to="/contact" className="service-card-link">
            <article>
              <h3>Industrial Facility Cleaning</h3>
              <p>Comprehensive cleaning of warehouses, production floors, and equipment zones with a focus on safety, compliance, and efficiency.</p>
            </article>
          </Link>
          <Link to="/contact" className="service-card-link">
            <article>
              <h3>Shared Space Cleaning</h3>
              <p>Regular upkeep of foyers, lifts, corridors, and staff amenities to keep high-traffic areas fresh, welcoming, and well-presented.</p>
            </article>
          </Link>
        </div>
      </section>
      
      <section>
        <div className="section-header">
          <h2>Why Adept Services</h2>
        </div>
        <div className="why-adept-cards">
          <Link to="/about" className="why-adept-card-link">
            <article className="why-adept-card">
              <div className="why-adept-icon">
                <img src="/services/commercial/trustworthy.png" alt="Trustworthy icon" />
              </div>
              <h3>Effective and Trustworthy</h3>
              <p>Adept's team of expert cleaners in Sydney specialises in delivering exceptional cleaning services. With a deep understanding of the unique needs of commercial spaces, we prioritise the details that matter most to our clients, ensuring a spotless and well-maintained environment every time.</p>
            </article>
          </Link>
          <Link to="/about" className="why-adept-card-link">
            <article className="why-adept-card">
              <div className="why-adept-icon">
                <img src="/services/commercial/time_money.png" alt="Time and money icon" />
              </div>
              <h3>Minimise Time and Cost</h3>
              <p>With the best cleaning equipment and a team of exceptional professionals, Adept Services is committed to delivering straightforward yet highly effective cleaning services. By opting for our cleaning services, clients can enjoy significant savings in both time and money.</p>
            </article>
          </Link>
          <Link to="/about" className="why-adept-card-link">
            <article className="why-adept-card">
              <div className="why-adept-icon">
                <img src="/services/commercial/equipment.png" alt="Equipment icon" />
              </div>
              <h3>Utilisation of Top-Quality and Reliable Equipment</h3>
              <p>Adept Services utilises the latest technologies and techniques, ensuring services are delivered quickly and efficiently. Our advanced approach guarantees the highest standards of cleaning quality every time.</p>
            </article>
          </Link>
        </div>
      </section>
      
      <section className="cta-section">
        <h2>Why Choose Adept?</h2>
        <p>Our expert cleaners deliver exceptional service with a can‑do attitude. By using the best equipment and techniques, we minimise time and cost while guaranteeing top‑quality results.</p>
        <a className="cta-button" href="/contact">Enquire Now</a>
      </section>
    </>
  )
}

export default CommercialCleaning
